"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigate = exports.Redirect = exports.NavLink = exports.Link = exports.memoryRouter = exports.browserRouter = exports.Router = exports.initialRoute = exports.router = exports.routerSwitch = exports.notFoundRouteCase = exports.route = void 0;
const react_1 = __importDefault(require("react"));
const url_pattern_1 = __importDefault(require("url-pattern"));
const widget_1 = require("../basics/widget");
/**
 * A helper function to create a typed-[[Route]] with no title.
 */
const route = (path, paramsToRoute) => ({ path, paramsToRoute });
exports.route = route;
/**
 * A helper function to construct a typed [[Route]] which has no path and no parameters.
 * It acts as a **catch-all** (default) router.
 */
const notFoundRouteCase = (makeRoute) => ({ paramsToRoute: makeRoute });
exports.notFoundRouteCase = notFoundRouteCase;
/**
 * @deprecated use {@link router} instead
 */
const routerSwitch = (options) => (routes) => (0, exports.router)(options)(routes);
exports.routerSwitch = routerSwitch;
/**
 * An adapter from an array of routes `R` into a widget `R`
 * Note: There is no support for "nested routing". All hereby supllied routes act at top-level.
 */
const router = (options) => (routes) => (0, widget_1.fromJSX)((setState) => react_1.default.createElement(exports.Router, { key: options === null || options === void 0 ? void 0 : options.key, routes: routes, setState: setState }));
exports.router = router;
const getCurrentLocation = () => {
    const { pathname, search } = window.location;
    return { pathname: pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname, search: search };
};
const getMatchedRoute = (location, routes) => routes
    .map((route) => ({
    route: route,
    match: route.path === undefined
        ? null
        : new url_pattern_1.default(route.path, { segmentValueCharset: "a-zA-Z0-9-_~ %,&.()':;!$*+@" }).match(location.pathname)
}))
    .find((routeAndMatch) => routeAndMatch.match !== null);
const getParams = (location, match) => {
    const searchParams = {};
    for (const [key, value] of new URLSearchParams(location.search)) {
        const currentValue = searchParams[key];
        if (searchParams[key] === undefined)
            searchParams[key] = value;
        if (typeof currentValue === 'string')
            searchParams[key] = [currentValue, value];
        if (Array.isArray(currentValue))
            searchParams[key] = [...currentValue, value];
    }
    const params = Object.assign(Object.assign({}, match), searchParams);
    return params;
};
const initialRoute = (routes) => {
    const currentLocation = getCurrentLocation();
    const matchedRoute = getMatchedRoute(currentLocation, routes);
    if (matchedRoute !== undefined) {
        const params = getParams(currentLocation, matchedRoute.match);
        return matchedRoute.route.paramsToRoute(params);
    }
};
exports.initialRoute = initialRoute;
const Router = (props) => {
    const [location, setLocation] = react_1.default.useState(getCurrentLocation());
    react_1.default.useEffect(() => {
        const checkRouteChanges = setInterval(() => {
            const currentLocation = getCurrentLocation();
            if (currentLocation.pathname !== location.pathname || currentLocation.search !== location.search) {
                setLocation(currentLocation);
                const matchedRoute = getMatchedRoute(currentLocation, props.routes);
                if (matchedRoute !== undefined) {
                    const params = getParams(currentLocation, matchedRoute.match);
                    props.setState(matchedRoute.route.paramsToRoute(params));
                    if (matchedRoute.route.title !== undefined)
                        document.title = matchedRoute.route.title;
                }
            }
        }, 100);
        return () => clearInterval(checkRouteChanges);
    }, [location, props.routes]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Router = Router;
/**
 * @deprecated
 * A `browserRouter` decorates a widget with a `ReactRouterDom.BrowserRouter` top-level component.
 * @param w is a widget, and *normally* this should contain a routerswitch
 */
const browserRouter = (options) => (w) => (0, widget_1.fromJSX)((onDone) => react_1.default.createElement(react_1.default.Fragment, { key: options === null || options === void 0 ? void 0 : options.key }, w.run(onDone)));
exports.browserRouter = browserRouter;
/**
 * @deprecated
 * A `memoryRouter` decorates a widget with a `ReactRouterDom.memoryRouter` top-level component.
 * This router behaves the same as the browserRouter, but does not change the url of the document.
 * This is useful for none browser environments like React native, electron app or when you simply
 * don't have a real web server
 * @see https://reactrouter.com/web/api/MemoryRouter
 * @param w is a widget, and *normally* this should contain a routerswitch
 */
const memoryRouter = (options) => (w) => (0, widget_1.fromJSX)((onDone) => react_1.default.createElement(react_1.default.Fragment, { key: options === null || options === void 0 ? void 0 : options.key }, w.run(onDone)));
exports.memoryRouter = memoryRouter;
const Link = (props) => {
    const { to, onClick, target } = props, rest = __rest(props, ["to", "onClick", "target"]);
    const isExternal = (() => {
        try {
            const url = new URL(to, window.location.href);
            return url.origin !== window.location.origin;
        }
        catch (e) {
            // If URL parsing fails, treat absolute http(s) as external
            return to.startsWith('http://') || to.startsWith('https://');
        }
    })();
    return (react_1.default.createElement("a", Object.assign({ href: to, onClick: (event) => {
            // For same-origin (or relative) URLs use client-side navigation
            if (!isExternal) {
                event.preventDefault();
                (0, exports.navigate)(to);
                if (onClick !== undefined)
                    onClick(event);
                return;
            }
            // External URL: allow opening in new tab/window when target is _blank
            event.preventDefault();
            if (target === '_blank') {
                window.open(to, '_blank');
            }
            else {
                // Full navigation for cross-origin URLs
                window.location.href = to;
            }
        }, target: target }, rest)));
};
exports.Link = Link;
/**
 * @todo
 */
const NavLink = (props) => react_1.default.createElement(exports.Link, Object.assign({}, props));
exports.NavLink = NavLink;
/**
 * @deprecated use {@link navigate} directly instead (to prevent using effects unnecessarily)
 */
const Redirect = (props) => {
    react_1.default.useEffect(() => (0, exports.navigate)(props.to), []);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Redirect = Redirect;
const navigate = (to) => window.history.pushState({}, '', to);
exports.navigate = navigate;
